import React from 'react';

import { IconProps } from './types';

const WaitingScreenIcon: React.FC<IconProps> = props => {
  const { width = '202', height = '178' } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.714 169.713V172.669L2.0512 156.13C1.37042 155.737 1.02336 155.059 1.00667 154.368H1L1.03003 151.719C1.12681 152.296 1.4672 152.837 2.04786 153.174L30.7106 169.713H30.714Z"
        fill="#0088FE"
      />
      <path d="M32.7782 170.901V173.861L30.7158 172.673V169.713L32.7782 170.901Z" fill="#0F6FCE" />
      <path
        d="M79.5622 155.94L43.5866 176.801C41.8246 177.823 39.652 177.826 37.89 176.808L35.5205 175.443V172.486L37.89 173.851C40.4229 175.313 41.057 175.313 43.5866 173.845L79.5622 152.98C80.1462 152.643 80.4733 152.079 80.5367 151.492V153.758C80.6135 154.489 80.2897 155.516 79.5622 155.94Z"
        fill="#0F6FCE"
      />
      <path d="M35.5181 172.486V175.443L32.7783 173.861V170.901L35.5181 172.486Z" fill="#0088FE" />
      <path
        d="M57.1619 57.4014V64.693C57.1619 65.524 57.6024 66.2915 58.3199 66.712L72.9699 75.2551"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M150.231 80.8853L114.562 101.493"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M150.231 80.8853L173.782 94.331C175.03 95.0452 176.569 95.0319 177.807 94.301L181.455 92.1451C182.065 91.7847 182.439 91.1306 182.439 90.4231V86.8089"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M133.141 55.9829C133.144 56.1131 133.141 59.8907 133.141 61.8429C133.141 62.5538 132.76 63.2112 132.146 63.5683L128.189 65.8742C127.304 66.3915 127.308 67.6729 128.195 68.1835L150.227 80.8814"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.9145 123.342L54.3728 144.156"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M100.843 63.4917L39.8715 93.9441C38.2997 94.8585 38.2997 97.1579 39.8715 98.0757L131.339 150.991C134.302 152.787 136.178 152.91 139.599 150.951L193.579 120.145C196.999 118.183 195.788 115.266 193.495 113.804L105.846 63.4917C104.297 62.5907 102.392 62.5907 100.843 63.4917Z"
        fill="#101841"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M122.856 143.242L177.019 112.079L188.366 112.245L188.399 114.351C188.406 115.553 187.765 116.661 186.724 117.261L132.133 148.508C130.575 149.402 128.656 149.396 127.107 148.488L122.856 145.995"
        fill="#0F6FCE"
      />
      <path
        d="M122.853 145.996L119.409 144.03L116.572 142.411L39.0244 97.7689C37.9899 97.1749 37.3491 96.0703 37.3491 94.8755V92.6763L41.7276 96.4707L116.576 139.648L119.412 141.27L122.856 143.242"
        fill="#0088FE"
      />
      <path d="M119.407 141.27V144.03L116.57 142.411V139.648L119.407 141.27Z" fill="#0F6FCE" />
      <path
        d="M188.366 112.386L177.019 112.219L123.033 143.229L119.525 141.22L116.675 139.591L41.8071 96.4574L37.3452 92.8198V95.0191C37.3452 96.2138 37.986 97.3184 39.0205 97.9125L116.572 142.555L119.408 144.173L122.852 146.139L127.104 148.632C128.656 149.54 130.575 149.55 132.13 148.652L186.721 117.405C187.762 116.808 188.399 115.697 188.396 114.495L188.363 112.389L188.366 112.386Z"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.4816 59.1502L38.5871 90.5604C37.0186 91.4614 36.8151 93.4371 38.5871 94.6252L127.081 145.602C128.623 146.489 130.525 146.493 132.07 145.608L187.285 114.055C188.743 113.217 188.747 111.111 187.285 110.274L98.4675 59.1502C96.9223 58.2624 95.0234 58.2624 93.4783 59.1502H93.4816Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.9601 62.5138L44.2584 90.9405C42.9835 91.6714 42.9835 93.5102 44.2584 94.2444L127.576 142.237C128.831 142.962 130.376 142.962 131.631 142.241L181.593 113.697C182.781 113.016 182.781 111.304 181.593 110.624L98.0182 62.5138C96.7634 61.7929 95.2182 61.7929 93.9634 62.5138H93.9601Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M115.815 97.1778C113.919 98.2424 113.902 100.962 115.781 102.05L142.242 117.278C144.188 118.406 146.598 118.366 148.506 117.175C150.068 116.2 150.032 113.911 148.433 112.99L120.897 97.2079C119.329 96.3001 117.397 96.2901 115.815 97.1745V97.1778Z"
        fill="#E5E7EA"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M102.131 104.854C100.235 105.919 100.219 108.639 102.098 109.726L128.769 125.038C130.714 126.166 133.124 126.126 135.033 124.934C136.595 123.96 136.558 121.671 134.959 120.749L107.214 104.884C105.645 103.976 103.713 103.966 102.131 104.851V104.854Z"
        fill="#E5E7EA"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M114.28 90.2298L90.6424 103.789C88.9203 104.787 86.7945 104.787 85.0725 103.786L65.593 92.4591C64.3181 91.7183 64.3215 89.8761 65.5996 89.1386L89.9616 75.0921C91.3365 74.3011 93.0318 74.3078 94.4001 75.1087L114.293 86.7057C115.638 87.4966 115.635 89.4456 114.283 90.2265L114.28 90.2298Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M101.995 84.0956V86.5184H101.988C101.938 87.4828 101.274 88.4373 99.999 89.1681C97.3426 90.7032 93.0344 90.7032 90.378 89.1681C89.0732 88.4139 88.4058 87.4295 88.3857 86.4417V83.9922L89.7907 84.0022L100.693 84.0856L101.991 84.0956H101.995Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.1863 88.0505C98.9443 88.0505 101.991 86.2919 101.991 84.1226C101.991 81.9534 98.9443 80.1948 95.1863 80.1948C91.4283 80.1948 88.3818 81.9534 88.3818 84.1226C88.3818 86.2919 91.4283 88.0505 95.1863 88.0505Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.3115 90.1797L71.3716 88.3242L87.1696 96.0297L90.41 92.7159C91.0007 92.7092 91.4212 92.7059 91.4212 92.7059V96.0998C91.4178 96.1265 91.4145 96.1532 91.4078 96.1799C91.1942 97.5881 90.2498 98.9664 88.5712 100.108C88.1774 100.378 87.6635 100.401 87.2464 100.161L71.7153 90.9205C71.455 90.767 71.3015 90.4834 71.3115 90.1797Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.2518 97.8916L71.6873 88.9047C71.2502 88.6511 71.2735 88.007 71.734 87.7934C76.5095 85.6009 83.4808 85.7778 87.8959 88.3307C92.4077 90.937 92.6346 95.0818 88.57 97.8416C88.1762 98.1086 87.6623 98.1286 87.2518 97.8916Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M165.136 107.266C164.982 106.515 164.525 105.821 163.771 105.384L144.663 94.418C143.565 93.784 142.343 93.467 141.119 93.467C139.894 93.467 138.729 93.7673 137.655 94.3713C136.603 94.962 136.033 95.9731 135.943 97.021C135.699 95.6862 136.26 94.2245 137.611 93.4703C138.686 92.8663 139.88 92.5659 141.072 92.5659C142.263 92.5659 143.521 92.8829 144.619 93.517L163.724 104.483C164.779 105.09 165.249 106.208 165.133 107.266H165.136Z"
        fill="#12173D"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M165.135 107.266C165.045 108.114 164.578 108.925 163.737 109.415L163.377 109.625C160.907 111.067 157.857 111.07 155.384 109.635L137.564 99.3236C136.646 98.7896 136.109 97.9387 135.942 97.0243C136.032 95.9764 136.603 94.9619 137.654 94.3746C138.728 93.7706 139.926 93.4702 141.118 93.4702C142.309 93.4702 143.564 93.7872 144.662 94.4213L163.77 105.387C164.525 105.821 164.982 106.518 165.135 107.269V107.266Z"
        fill="white"
        stroke="black"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M159.005 103.765C158.915 104.613 158.448 105.424 157.607 105.914L157.246 106.125C154.777 107.566 151.727 107.57 149.254 106.135L137.564 99.3202C136.646 98.7862 136.109 97.9352 135.942 97.0209C136.032 95.973 136.603 94.9585 137.654 94.3712C138.728 93.7671 139.926 93.4668 141.118 93.4668C142.309 93.4668 143.564 93.7838 144.662 94.4179L157.637 101.886C158.391 102.32 158.848 103.018 159.002 103.769L159.005 103.765Z"
        fill="#0088FE"
      />
      <path
        d="M165.135 107.266C165.045 108.114 164.578 108.925 163.737 109.415L163.377 109.625C160.907 111.067 157.857 111.07 155.384 109.635L137.564 99.3236C136.646 98.7896 136.109 97.9387 135.942 97.0243C136.032 95.9764 136.603 94.9619 137.654 94.3746C138.728 93.7706 139.926 93.4702 141.118 93.4702C142.309 93.4702 143.564 93.7872 144.662 94.4213L163.77 105.387C164.525 105.821 164.982 106.518 165.135 107.269V107.266Z"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M159.413 95.416V104.433H159.409C159.399 105.13 158.932 105.825 158.011 106.359C157.24 106.802 156.266 107.066 155.261 107.143C155.124 107.153 154.984 107.159 154.844 107.163C154.464 107.173 154.083 107.156 153.706 107.116C152.805 107.013 151.941 106.762 151.247 106.359C150.312 105.818 149.845 105.11 149.845 104.403V95.416H159.413Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M159.411 95.416V104.433H159.407C159.397 105.13 158.93 105.825 158.009 106.359C157.238 106.802 156.264 107.066 155.259 107.143V95.416H159.411Z"
        fill="#0087FF"
      />
      <path
        d="M154.475 95.416V107.163C154.095 107.173 153.714 107.156 153.337 107.116V95.416H154.475Z"
        fill="#0087FF"
      />
      <path
        d="M159.413 95.416V104.433H159.409C159.399 105.13 158.932 105.825 158.011 106.359C157.24 106.802 156.266 107.066 155.261 107.143C155.124 107.153 154.984 107.159 154.844 107.163C154.464 107.173 154.083 107.156 153.706 107.116C152.805 107.013 151.941 106.762 151.247 106.359C150.312 105.818 149.845 105.11 149.845 104.403V95.416H159.413Z"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M154.626 98.1757C157.269 98.1757 159.412 96.9386 159.412 95.4126C159.412 93.8865 157.269 92.6494 154.626 92.6494C151.983 92.6494 149.841 93.8865 149.841 95.4126C149.841 96.9386 151.983 98.1757 154.626 98.1757Z"
        fill="#101841"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M32.5863 28.9245L32.603 36.6869L62.952 53.8838L68.9591 50.4064C70.2239 49.6722 71.0015 48.3206 71.0015 46.8589L70.9314 14.2506L71.6322 13.1126L72.6567 8.44377L72.7201 7.35916C72.7201 7.35916 70.6978 6.46812 70.6444 6.46812C70.0737 6.09768 69.0558 5.98421 68.3784 6.37467L34.6287 25.3703C33.3639 26.1012 32.583 27.4561 32.583 28.9178L32.5863 28.9245Z"
        fill="#0087FF"
      />
      <path
        d="M32.5947 32.165L32.5981 33.63L46.3938 41.6692L46.3505 40.1809L32.5947 32.165Z"
        fill="#0F6FCE"
      />
      <path
        d="M32.5986 35.3452L46.3481 43.3546L46.3681 44.3258L62.9509 53.887L37.4143 69.7957L35.789 72.4321L33.9903 71.2741C33.226 70.887 32.6687 70.1027 32.6687 69.1249L32.5986 36.6901V35.3452Z"
        fill="#0F6FCE"
      />
      <path
        d="M34.6326 25.3803L68.3823 6.3813C69.0597 5.99084 69.884 6.21444 70.6483 6.47474C70.7017 6.47474 72.7241 7.36579 72.7241 7.36579L72.6606 8.4504L71.6361 13.1192L70.9353 14.2572L71.0054 46.8655C71.0054 48.3272 70.2278 49.6788 68.963 50.413L62.9559 53.8904L37.4193 69.7991L35.794 72.4355L33.9952 71.2775C33.231 70.8904 32.6737 70.1061 32.6737 69.1283L32.6036 36.6936L32.5869 28.9311C32.5869 27.4694 33.3678 26.1178 34.6326 25.3836V25.3803Z"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.5942 8.99444L73.6776 49.7156C73.6776 51.1773 72.9001 52.5289 71.6352 53.2598L38.2293 72.449C36.6241 73.3801 34.6118 72.2187 34.6118 70.3632L34.5283 30.1626C34.5283 28.7009 35.3092 27.3493 36.5741 26.6151L70.7008 7.32582C71.9856 6.58161 73.5942 7.50937 73.5942 8.99444Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.758 30.3963L56.8132 27.86C55.4884 27.6531 54.821 28.0703 54.1101 29.1148L42.7705 45.4935L60.1637 48.4336L69.758 30.3963Z"
        fill="#0087FF"
      />
      <path
        d="M69.758 30.3963L56.8132 27.86C55.4884 27.6531 54.821 28.0703 54.1101 29.1148L42.7705 45.4935L60.1637 48.4336L69.758 30.3963"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M67.9854 25.6209L68.0421 37.7281C68.0421 38.7326 67.5082 39.6569 66.6405 40.1609L47.0681 51.5873C45.9669 52.2247 44.5853 51.4304 44.5853 50.1556L44.5286 38.4923C44.5286 37.4878 45.0625 36.5601 45.9335 36.0595L66.0031 24.4763C66.8841 23.9657 67.9887 24.6031 67.9887 25.6209H67.9854Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.7554 30.3965V45.9409C69.7554 46.8052 69.2948 47.6028 68.544 48.0333L44.5165 61.8491C43.7356 62.2963 42.7645 61.7356 42.7612 60.838L42.7278 45.5505L59.1599 43.4614L69.7554 30.3998V30.3965Z"
        fill="#E5E7EA"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4309 61.8989L56.4892 41.5389C57.1466 40.5044 58.9119 39.3764 59.9598 40.0105L69.7543 45.9406C69.7543 45.9406 69.7944 47.3389 68.5429 48.033L44.5155 61.8488C44.5155 61.8488 44.0182 62.1892 43.4309 61.8989Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M164.288 42.2163V71.0568C164.288 72.0413 163.808 72.8556 163.11 73.3596L163.12 73.3729L161.038 74.7579C161.038 74.7579 156.232 70.376 142.629 61.252L164.292 42.2163H164.288Z"
        fill="#101841"
      />
      <path
        d="M164.289 35.3648V42.2162L142.627 61.2519C138.549 58.5154 134.407 55.7388 130.54 53.1424L114.02 43.6112L113.69 41.8625L109.225 44.6758L104.679 1.74869L105.847 1.29149C107.683 0.330359 108.684 0.29365 110.102 1.08458L161.566 30.6526C163.251 31.6238 164.289 33.4192 164.289 35.3648Z"
        fill="#0087FF"
      />
      <path
        d="M164.289 40.2544V43.3012L157.407 47.3025L159.954 42.7639L164.289 40.2544Z"
        fill="#0087FF"
      />
      <path
        d="M164.289 38.502V40.3374L157.407 44.342L159.954 41.0115L164.289 38.502Z"
        fill="#101841"
      />
      <path
        d="M161.565 30.6961L109.708 0.851065C108.37 0.0801592 107.305 0.5407 105.803 1.20815L104.675 1.79217L107.509 43.3577L111.974 40.5443L114.016 43.6547L130.536 53.1859C134.404 55.7822 138.545 58.5588 142.623 61.2954C156.226 70.4194 161.031 74.8012 161.031 74.8012L163.114 73.4163L163.104 73.4029C163.801 72.899 164.282 72.0847 164.282 71.1002V35.2882C164.282 33.0355 163.244 31.6673 161.559 30.6961H161.565Z"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.843 4.8561V53.6467L112.438 48.1002L158.108 74.8883C160.004 75.983 162.373 74.6147 162.373 72.4254V36.7302C162.373 34.7846 161.335 32.9891 159.65 32.0213L107.956 1.89929C105.68 0.59109 102.843 2.23302 102.843 4.8561Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M154.155 43.114C154.155 45.4735 151.592 46.9419 149.556 45.7505L112.596 24.6157C111.352 23.8881 110.584 22.5532 110.574 21.1115C110.561 18.7354 113.13 17.2403 115.189 18.4217L151.929 39.2762C153.304 40.0638 154.152 41.5289 154.152 43.114H154.155Z"
        fill="#E5E7EA"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M154.155 57.177C154.155 59.5365 151.592 61.0049 149.556 59.8135L112.596 38.6786C111.352 37.9511 110.584 36.6162 110.574 35.1745C110.561 32.7984 113.13 31.3033 115.189 32.4847L151.929 53.3392C153.304 54.1268 154.152 55.5918 154.152 57.177H154.155Z"
        fill="#E5E7EA"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeMiterlimit="10"
      />
      <path
        d="M200.998 70.5628V75.4986L185.66 85.9876L179.012 82.33L174.837 80.1641L172.755 57.8012L170.462 54.524L172.331 53.5662L172.398 53.5262C173.673 53.1891 174.881 53.1057 175.798 53.5262L198.271 65.854C199.957 66.8218 200.995 68.6205 200.995 70.5628H200.998Z"
        fill="#0087FF"
      />
      <path
        d="M200.996 75.4985V91.9707C200.996 93.1721 200.282 94.1265 199.327 94.5603H199.321L197.599 95.8284L193.948 90.6091L185.662 85.9905L200.999 75.5019L200.996 75.4985Z"
        fill="#101841"
      />
      <path
        d="M200.998 73.0859L197.434 75.3919V75.4753L195.201 78.2585V79.5033L200.998 76.1328V74.908V73.1694V73.0859Z"
        fill="#0087FF"
      />
      <path
        d="M200.998 73.086V71.334L195.201 74.7078V76.4598V76.5433L200.998 73.1694V73.086Z"
        fill="#101841"
      />
      <path
        d="M200.998 70.6028V92.0112C200.998 93.2126 200.284 94.1671 199.329 94.6009H199.323L197.467 95.8224L193.946 90.6463L179.012 82.3699L174.504 79.036L172.755 57.8378L170.462 54.5606L172.331 53.6028L172.398 53.5627C173.546 52.9754 174.664 52.912 175.798 53.5627L198.271 65.8906C199.957 66.8584 200.995 68.6571 200.995 70.5994L200.998 70.6028Z"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M168.587 78.2084C168.587 79.7535 169.411 81.1785 170.75 81.9527L194.795 95.7857C196.69 96.8803 199.06 95.512 199.06 93.3228V71.9143C199.06 69.9687 198.022 68.1732 196.336 67.2054L173.703 54.6073C171.427 53.2991 168.59 54.941 168.59 57.5641V78.2084H168.587Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M180.721 66.5679C181.028 66.6547 181.335 66.915 181.505 67.262L182.756 69.8183C182.897 70.1053 182.967 70.3923 182.97 70.6626C182.977 71.1732 182.753 71.6137 182.339 71.7872L181.996 71.924C181.595 72.0909 181.375 72.508 181.385 73.0019C181.388 73.2656 181.458 73.5559 181.595 73.8362L183.154 76.9965C183.411 77.5204 183.844 77.8909 184.285 78.0143C184.522 78.0811 184.762 78.0744 184.976 77.9843L185.319 77.8475C185.54 77.7574 185.78 77.7474 186.024 77.8174C186.484 77.9476 186.938 78.3314 187.205 78.8786L188.456 81.4316C188.55 81.6151 188.593 81.812 188.6 81.9955C188.6 82.3326 188.46 82.6296 188.186 82.7431C187.388 83.0734 186.501 83.0868 185.62 82.8398C183.951 82.376 182.309 80.9844 181.348 79.0255L178.752 73.7261C178.238 72.6849 177.984 71.6203 177.971 70.6359C177.941 68.7838 178.749 67.202 180.25 66.5846C180.394 66.5212 180.554 66.5212 180.717 66.5646L180.721 66.5679Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.3 133.28L76.497 132.786C76.744 132.749 76.8074 132.419 76.5905 132.292L74.2511 130.94C74.1143 130.864 73.9441 130.917 73.8774 131.057L73.0197 132.903C72.9296 133.096 73.0931 133.31 73.3 133.276V133.28Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M145.052 84.0254L148.249 83.5315C148.496 83.4948 148.56 83.1644 148.343 83.0376L146.003 81.686C145.867 81.6093 145.696 81.6627 145.63 81.8028L144.772 83.6483C144.682 83.8418 144.845 84.0554 145.052 84.022V84.0254Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M163.076 88.5544L164.341 90.6135C164.444 90.7169 164.614 90.7169 164.718 90.6135L166.543 89.1084C166.71 88.9415 166.59 88.6545 166.353 88.6545L163.263 88.1006C163.026 88.1006 162.909 88.3876 163.076 88.5544Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.8738 70.2459L64.0162 68.4005C63.9494 68.2603 63.7759 68.2036 63.6424 68.2837L61.3031 69.6352C61.0862 69.7621 61.1462 70.0891 61.3965 70.1291L64.5935 70.623C64.8038 70.6564 64.9639 70.4395 64.8738 70.2493V70.2459Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M136.817 72.8724L135.96 71.027C135.893 70.8868 135.72 70.8301 135.586 70.9102L133.247 72.2617C133.03 72.3885 133.09 72.7156 133.34 72.7556L136.537 73.2495C136.747 73.2829 136.908 73.066 136.817 72.8757V72.8724Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.5367 153.837V151.468L78.6512 151.475L43.0494 130.994C41.6177 130.17 39.8556 130.173 38.424 130.994L2.45838 151.755L1.03337 151.762L1 154.191H1.00334C1.02002 154.882 1.3671 155.559 2.0479 155.953L37.8833 176.631C39.6454 177.649 41.8213 177.645 43.58 176.624L79.5589 155.763C80.2864 155.343 80.6102 154.572 80.5334 153.841L80.5367 153.837Z"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.0516 128.564L79.5578 149.566C80.8794 150.327 80.8827 152.232 79.5645 152.996L43.5856 173.858C41.0559 175.326 40.4219 175.326 37.8889 173.864L2.05013 153.187C0.655163 152.382 0.655163 150.367 2.05013 149.559L38.4262 128.571C39.8579 127.747 41.6199 127.743 43.0516 128.571V128.564Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.7455 118.339C36.2569 115.746 32.1888 115.506 29.2486 117.215L27.5166 118.223C30.4534 116.514 34.5215 116.757 39.0134 119.347C47.9373 124.5 55.1457 136.985 55.1157 147.24C55.1023 152.333 53.3036 155.917 50.4035 157.602L52.1355 156.594C55.0356 154.909 56.8344 151.325 56.8477 146.232C56.8778 135.98 49.6693 123.492 40.7455 118.339Z"
        fill="#0087FF"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.0112 119.347C47.935 124.5 55.1435 136.985 55.1135 147.24C55.0834 157.492 47.8282 161.63 38.9078 156.477C29.9839 151.325 22.7755 138.837 22.8055 128.585C22.8355 118.333 30.0907 114.198 39.0145 119.347H39.0112Z"
        fill="white"
        stroke="#101841"
        strokeWidth="0.333715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7786 137.091L34.475 141.216L44.4898 137.906"
        stroke="#02C902"
        strokeWidth="5.00572"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WaitingScreenIcon;
